import React from "react";

import '../../style_new.css';

const Team = () => {
  return (
    <>
      {/* team section start */}

      <div class="container-xxl py-5">
            <div class="container">
              <div class="row g-5 align-items-end mb-5">
                <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                  <div class="border-start border-5 border-primary ps-4">
                    <h6 class="text-body text-uppercase mb-2">Our Team</h6>
                    <h1 class="display-6 mb-0">Our Expert Team</h1>
                  </div>
                </div>
                <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                  <p class="mb-0">
                     Our expert team brings together skilled professionals with years of experience, passion, and precision. We collaborate closely to deliver outstanding results, ensuring every project meets the highest standards.

                  </p>
                </div>
              </div>
              <div class="row g-4">
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                  <div class="team-item position-relative">
                    <img class="img-fluid team-img" src="./images/team-1.jpg" alt="" />
                    <div class="team-text bg-white p-4">
                      <h5>William Kuffour Bonsu</h5>
                      <span>Managing Director</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                  <div class="team-item position-relative">
                    <img class="img-fluid team-img" src="./images/feature.jpg" alt="" />
                    <div class="team-text bg-white p-4">
                      <h5>Yvonne Boateng</h5>
                      <span>Director</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                  <div class="team-item position-relative">
                    <img class="img-fluid team-img" src="./images/team-3.jpg" alt="" />
                    <div class="team-text bg-white p-4">
                      <h5>Issac Agyei Mensah</h5>
                      <span>General Manager</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* team section end */}
    </>
  );
};
  
export default Team;